(function () {
   function initMtmV2(root) {
      var form = root.querySelector("[data-mtm-form]");
      if (!form) return;

      var cards = Array.prototype.slice.call(form.querySelectorAll("[data-nutri-card]"));
      var totalEl = form.querySelector("[data-mtm-total]");
      var selectedList = form.querySelector("[data-mtm-selected-list]");
      var jsonInput = form.querySelector("[data-mtm-json]");
      var submitButton = form.querySelector('.mtm__submit[type="submit"]');
      var maxTotal = parseInt(form.getAttribute("data-max-total") || "18", 10);
      var loadingOverlay = root.querySelector("[data-mtm-loading-overlay]");
      var progressBar = root.querySelector("[data-mtm-progress-bar]");
      var timerEl = root.querySelector("[data-mtm-timer]");
      var loadingInterval = null;
      var webhookUrl = "https://codageparis.app.n8n.cloud/webhook/v2/custom-serum-workflow";
      var detailOverlay = root.querySelector("[data-mtm-detail-overlay]");
      var detailTitle = root.querySelector("[data-mtm-detail-title]");
      var detailMolecule = root.querySelector("[data-mtm-detail-molecule]");
      var detailDescription = root.querySelector("[data-mtm-detail-description]");
      var detailActifsWrap = root.querySelector("[data-mtm-detail-actifs-wrap]");
      var detailActifs = root.querySelector("[data-mtm-detail-actifs]");
      var detailLong = root.querySelector("[data-mtm-detail-long]");

      function getQty(card) {
         var input = card.querySelector("[data-qty-input]");
         return parseInt(input.value || "0", 10);
      }

      function setQty(card, qty) {
         var input = card.querySelector("[data-qty-input]");
         input.value = String(Math.max(0, Math.min(2, qty)));
      }

      function getTotal() {
         return cards.reduce(function (sum, card) {
            return sum + getQty(card);
         }, 0);
      }

      function renderSelected() {
         var selected = cards
            .map(function (card) {
               return {
                  handle: card.getAttribute("data-handle") || "",
                  title: card.getAttribute("data-title") || "",
                  molecule: card.getAttribute("data-molecule") || "",
                  quantity: getQty(card),
               };
            })
            .filter(function (item) {
               return item.quantity > 0;
            });

         var total = selected.reduce(function (sum, item) {
            return sum + item.quantity;
         }, 0);

         if (totalEl) {
            totalEl.textContent = String(total);
         }

         if (jsonInput) {
            jsonInput.value = JSON.stringify(selected);
         }

         if (!selectedList) return;

         if (selected.length === 0) {
            selectedList.innerHTML = '<p class="mtm__summary-empty">Aucun Nutri-element selectionne.</p>';
            return;
         }

         selectedList.innerHTML = selected
            .map(function (item) {
               var label = item.molecule ? item.molecule + " - " + item.title : item.title;
               return '<span class="mtm__summary-pill">' + label + " x" + item.quantity + "</span>";
            })
            .join("");
      }

      function updateControlsState() {
         var total = getTotal();

         cards.forEach(function (card) {
            var qty = getQty(card);
            var increaseBtn = card.querySelector('[data-qty-action="increase"]');
            var decreaseBtn = card.querySelector('[data-qty-action="decrease"]');

            if (increaseBtn) {
               increaseBtn.disabled = qty >= 2 || total >= maxTotal;
            }

            if (decreaseBtn) {
               decreaseBtn.disabled = qty <= 0;
            }
         });
      }

      function getCheckedValue(name) {
         var input = form.querySelector('input[name="' + name + '"]:checked');
         return input ? input.value : "";
      }

      function getFieldValue(names) {
         for (var i = 0; i < names.length; i += 1) {
            var field = form.querySelector('[name="' + names[i] + '"]');
            if (field && typeof field.value === "string") {
               return field.value.trim();
            }
         }

         return "";
      }

      function getSelectedVolumePrice() {
         var selectedVolume = form.querySelector('input[name="volume"]:checked');
         if (!selectedVolume) {
            return 0;
         }

         var directPrice = selectedVolume.getAttribute("data-price");
         if (directPrice !== null && directPrice !== "") {
            var directParsed = parseFloat(String(directPrice).replace(",", "."));
            if (!isNaN(directParsed)) {
               return directParsed;
            }
         }

         var label = selectedVolume.closest("label");
         var priceText = "";

         if (label) {
            var priceNode = label.querySelector(".mtm__choice-meta");
            if (priceNode) {
               priceText = (priceNode.textContent || "").trim();
            }
         }

         var parsed = parseFloat(priceText.replace(/[^0-9.,-]/g, "").replace(",", "."));
         return isNaN(parsed) ? 0 : parsed;
      }

      function getNutriMap() {
         var nutri = {};

         cards.forEach(function (card) {
            var quantity = getQty(card);
            if (quantity <= 0) {
               return;
            }

            var key = card.getAttribute("data-molecule") || card.getAttribute("data-handle") || card.getAttribute("data-title") || "NUTRI";
            key = String(key).trim();

            if (!key) {
               key = "NUTRI";
            }

            key = key.toUpperCase();

            nutri[key] = String(quantity);
         });

         return nutri;
      }

      function getSellerShopifyId() {
         var raw = form.getAttribute("data-seller-shopify-id") || getFieldValue(["sellerShopifyId", "seller_shopify_id"]);

         if (!raw) {
            var params = new URLSearchParams(window.location.search);
            raw = params.get("sellerShopifyId") || params.get("seller_shopify_id") || "";
         }

         if (!raw) {
            return null;
         }

         // Accept plain ids, stringified numbers, or gid-like values by extracting the last digit sequence.
         var normalized = String(raw).trim();
         var match = normalized.match(/(\d+)(?!.*\d)/);
         var parsed = parseInt(match ? match[1] : normalized, 10);
         return isNaN(parsed) ? null : parsed;
      }

      function buildDebugPayload() {
         var firstName = getFieldValue(["fName", "first_name", "firstname"]);
         var lastName = getFieldValue(["name", "last_name", "lastname"]);
         var initials = getFieldValue(["initials"]);

         return {
            formData: {
               volume: getCheckedValue("volume"),
               base: getCheckedValue("base"),
               nutri: getNutriMap(),
               dosage: getCheckedValue("dosage") || getCheckedValue("application_moment"),
               name: lastName,
               fName: firstName,
               initials: initials,
               mail: getFieldValue(["mail", "email"]),
               message: getFieldValue(["message", "notes"]),
               price: getSelectedVolumePrice(),
               sellerShopifyId: getSellerShopifyId(),
            },
         };
      }

      function syncUi() {
         renderSelected();
         updateControlsState();
         var payload = buildDebugPayload();

         if (jsonInput) {
            jsonInput.value = JSON.stringify(payload);
         }
      }

      function setSubmitLoading(isLoading) {
         if (!submitButton) {
            return;
         }

         if (!submitButton.hasAttribute("data-default-label")) {
            submitButton.setAttribute("data-default-label", submitButton.textContent || "Save formula");
         }

         var defaultLabel = submitButton.getAttribute("data-default-label") || "Save formula";
         submitButton.disabled = isLoading;
         submitButton.textContent = isLoading ? "Sending..." : defaultLabel;

         // Show/hide loading popup
         if (loadingOverlay) {
            loadingOverlay.hidden = !isLoading;
            document.documentElement.classList.toggle("mtm--loading-open", isLoading);
         }

         if (isLoading) {
            var remaining = 60;

            if (timerEl) {
               timerEl.textContent = "1:00";
            }

            if (loadingInterval) {
               clearInterval(loadingInterval);
               loadingInterval = null;
            }

            loadingInterval = setInterval(function () {
               remaining -= 1;
               if (remaining <= 0) {
                  remaining = 0;
                  clearInterval(loadingInterval);
                  loadingInterval = null;
               }
               if (timerEl) {
                  var minutes = Math.floor(remaining / 60);
                  var seconds = remaining % 60;
                  timerEl.textContent = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
               }
            }, 1000);
         } else {
            if (loadingInterval) {
               clearInterval(loadingInterval);
               loadingInterval = null;
            }
            if (timerEl) {
               timerEl.textContent = "1:00";
            }
         }
      }

      function setDetailLongText(text) {
         if (!detailLong) {
            return;
         }

         detailLong.innerHTML = "";

         var lines = String(text || "")
            .split(/\r?\n/)
            .map(function (line) {
               return line.trim();
            })
            .filter(function (line) {
               return line.length > 0;
            });

         if (lines.length === 0) {
            return;
         }

         lines.forEach(function (line) {
            var p = document.createElement("p");
            p.textContent = line;
            detailLong.appendChild(p);
         });
      }

      function openDetailDrawer(button) {
         if (!detailOverlay) {
            return;
         }

         var card = button.closest("[data-nutri-card]");
         if (!card) {
            return;
         }

         var title = card.getAttribute("data-title") || "";
         var molecule = card.getAttribute("data-molecule") || "";
         var description = card.getAttribute("data-detail-description") || "";
         var longDescription = card.getAttribute("data-detail-long") || "";
         var actifsRaw = card.getAttribute("data-detail-actifs") || "";
         var actifsItems = actifsRaw
            .split("||")
            .map(function (item) {
               return item.trim();
            })
            .filter(function (item) {
               return item.length > 0;
            });

         if (detailTitle) {
            detailTitle.textContent = title;
         }

         if (detailMolecule) {
            detailMolecule.textContent = molecule;
         }

         if (detailDescription) {
            detailDescription.textContent = description;
         }

         if (detailActifs && detailActifsWrap) {
            detailActifs.innerHTML = "";

            if (actifsItems.length > 0) {
               actifsItems.forEach(function (item) {
                  var badge = document.createElement("span");
                  badge.className = "mtm__badge";
                  badge.textContent = item;
                  detailActifs.appendChild(badge);
               });
               detailActifsWrap.hidden = false;
            } else {
               detailActifsWrap.hidden = true;
            }
         }

         setDetailLongText(longDescription);

         detailOverlay.hidden = false;
         document.documentElement.classList.add("mtm--drawer-open");
         detailOverlay.setAttribute("data-drawer-state", "opening");

         setTimeout(function () {
            detailOverlay.removeAttribute("data-drawer-state");
         }, 350);
      }

      function closeDetailDrawer() {
         if (!detailOverlay) {
            return;
         }

         detailOverlay.setAttribute("data-drawer-state", "closing");

         setTimeout(function () {
            detailOverlay.hidden = true;
            document.documentElement.classList.remove("mtm--drawer-open");

            requestAnimationFrame(function () {
               detailOverlay.removeAttribute("data-drawer-state");
            });
         }, 350);
      }

      cards.forEach(function (card) {
         card.addEventListener("click", function (event) {
            var actionEl = event.target.closest("[data-qty-action]");
            if (!actionEl) return;

            event.preventDefault();

            var action = actionEl.getAttribute("data-qty-action");
            var currentQty = getQty(card);
            var total = getTotal();

            if (action === "increase") {
               if (currentQty >= 2 || total >= maxTotal) return;
               setQty(card, currentQty + 1);
            }

            if (action === "decrease") {
               if (currentQty <= 0) return;
               setQty(card, currentQty - 1);
            }

            syncUi();
         });
      });

      form.addEventListener("submit", function (event) {
         event.preventDefault();

         // Validate required fields
         var initials = getFieldValue(["initials"]).trim();
         var firstName = getFieldValue(["first_name"]).trim();
         var lastName = getFieldValue(["last_name"]).trim();
         var email = getFieldValue(["email"]).trim();

         if (!/^[A-Za-z]{1,2}$/.test(initials)) {
            alert("Please enter 1 or 2 initials (letters only)");
            return;
         }

         if (!firstName) {
            alert("Please enter your first name");
            return;
         }

         if (!lastName) {
            alert("Please enter your last name");
            return;
         }

         if (!email) {
            alert("Please enter your email");
            return;
         }

         if (getTotal() === 0) {
            alert("Please select at least one nutri-element");
            return;
         }

         syncUi();
         var payload = buildDebugPayload();
         console.log("[MTM] Form submit payload", payload);

         setSubmitLoading(true);

         fetch(webhookUrl, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify(payload.formData),
            redirect: "follow",
         })
            .then(function (response) {
               if (response.status === 301) {
                  window.location.href = "https://www.codageparis.com/fr/account";
                  return;
               }

               if (response.status === 500) {
                  alert("Error while creating made-to-measure order");
               }

               console.log("[MTM] Webhook response", response.status, response);
            })
            .catch(function (error) {
               console.error("[MTM] Webhook error", error);
            })
            .finally(function () {
               setTimeout(function () {
                  setSubmitLoading(false);
               }, 3000);
            });
      });

      form.addEventListener("change", function (event) {
         var target = event.target;
         if (!target || !target.name) {
            return;
         }

         if (
            target.name === "volume" ||
            target.name === "base" ||
            target.name === "dosage" ||
            target.name === "application_moment" ||
            target.name === "first_name" ||
            target.name === "last_name" ||
            target.name === "email" ||
            target.name === "notes" ||
            target.name === "fName" ||
            target.name === "name" ||
            target.name === "mail" ||
            target.name === "message" ||
            target.name === "initials"
         ) {
            syncUi();
         }
      });

      form.addEventListener("click", function (event) {
         var detailBtn = event.target.closest("[data-mtm-nutri-detail-btn]");
         if (!detailBtn) {
            return;
         }

         event.preventDefault();
         openDetailDrawer(detailBtn);
      });

      if (detailOverlay) {
         detailOverlay.addEventListener("click", function (event) {
            if (event.target.closest("[data-mtm-detail-close]")) {
               closeDetailDrawer();
            }
         });

         document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && !detailOverlay.hidden) {
               closeDetailDrawer();
            }
         });
      }

      syncUi();
   }

   document.addEventListener("DOMContentLoaded", function () {
      var sections = document.querySelectorAll(".mtm");
      sections.forEach(function (section) {
         initMtmV2(section);
      });
   });
})();
